import React, { useContext } from "react"
import { FaPhoneAlt } from "react-icons/fa";
import { DiscadorContext } from '../../Discador'

export function PhoneOffButton() {
  const {
    onCall,
    isLogged,
    finalizarChamada,
    dadosLogin,
  } = useContext(DiscadorContext);
  return <>
    <div >
      <button className="flex items-center gap-2 text-white bg-error rounded-sm p-1 text-sm px-2 disabled:bg-red-200 disabled:hover:bg-red-200"
        disabled={!onCall || !isLogged}
        onClick={() => {
          finalizarChamada(dadosLogin!.idUsuario);
        }}>
        {/* <FaPhoneAlt /> */}
        {/* <FaPhoneAlt className="fill-white" >{children}</FaPhoneAlt> */}
        Desligar
      </button>
    </div>
  </>
} 